import { Outlet } from "@tanstack/react-router";

import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { AGENCY } from "@/lib/agency";

export function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground antialiased">
      <SiteHeader agency={AGENCY} />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
